import React, { useMemo } from 'react'
import { useQuery } from '@apollo/client'
import { useAuthContext } from '../auth'
import { AppsContext } from './AppsContext'
import { AdminApp } from '@acorns/admin-framework-binding'
import { log } from '../../utils/log'
import { APP_ACCESS_QUERY } from '../../operations/app-access.query'

interface Props {
  children: React.ReactNode
}

export function AppsProvider({ children }: Props) {
  const { adminUser } = useAuthContext()

  const { data, loading } = useQuery(APP_ACCESS_QUERY, {
    variables: {
      roles: adminUser?.roles,
    },
    skip: !adminUser,
    fetchPolicy: 'network-only',
  })

  log(data)

  const apps: AdminApp[] | null = data?.adminApps

  const appPaths: string[] | null = useMemo(() => apps?.map(({ rootPath }) => rootPath), [apps])

  return (
    <AppsContext.Provider
      value={{
        loading,
        apps,
        appPaths,
      }}
    >
      {children}
    </AppsContext.Provider>
  )
}
